export const GET_LIST_RANKS_WATCHER =
  "app/WidgetAnalysisSegment/GET_LIST_RANKS_WATCHER"
export const GET_LIST_RANKS_SUCCESS =
  "app/WidgetAnalysisSegment/GET_LIST_RANKS_SUCCESS"
export const GET_LIST_RANKS_FAILED =
  "app/WidgetAnalysisSegment/GET_LIST_RANKS_FAILED"
